import { DialogComponent } from '@theme/dialog';

class DrawerTrigger extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('shopify:block:select', this.#handleBlockSelect);
    this.addEventListener('shopify:block:deselect', this.#handleBlockDeselect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('shopify:block:select', this.#handleBlockSelect);
    this.removeEventListener('shopify:block:deselect', this.#handleBlockDeselect);
  }

  #handleBlockSelect = () => {
    this.showDialog();
  };

  #handleBlockDeselect = () => {
    this.closeDialog();
  };

  openDrawer() {
    this.showDialog();
  }

  closeDrawer() {
    this.closeDialog();
  }
}

if (!customElements.get('drawer-trigger')) {
  customElements.define('drawer-trigger', DrawerTrigger);
}